import React from "react";
import { observer } from "mobx-react-lite";
import { IApplicationContext } from "../context";
import { TermsOfServiceDialog } from '#glib/ui/component/user/TermsOfServiceDialog';

/**
 * TermsOfServiceModal
 */
export const TermsOfServiceModal: React.FunctionComponent<IApplicationContext> = observer(props => {

    const onClose = () => props.store.ui.mset({ showToS: false });

    return (
        <TermsOfServiceDialog
            isOpen={props.store.ui.data.showToS}
            onClose={onClose}
        />
    )
})